import React from 'react';
import './ProductMetricsGrid.css';
import { formatCount, formatMinutes, formatPercent } from '../utils/adminFormatters';

const healthLabel = (health) => {
  const map = {
    ok: 'OK',
    warning: 'Warning',
    critical: 'Critical'
  };
  return map[health] || health || null;
};

const ProductMetricsGrid = ({ metrics, loading }) => {
  if (loading) {
    return (
      <div className="stats-section">
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Загрузка продуктовых метрик...</p>
        </div>
      </div>
    );
  }

  if (!metrics) {
    return (
      <div className="stats-section">
        <div className="empty-message">Не удалось загрузить продуктовые метрики.</div>
      </div>
    );
  }

  const activation = metrics.activationRate || {};
  const ttv = metrics.timeToValue || {};
  const retention = metrics.retentionRate || {};
  const stickiness = metrics.stickinessRatio || {};
  const stickinessSummaries = stickiness.summaries || {};

  const day7 = retention.day7 || {};
  const day30 = retention.day30 || {};

  const cards = [
    {
      label: 'Activation rate',
      value: formatPercent(activation.ratePercent),
      meta: `${formatCount(activation.activatedUsers)} из ${formatCount(activation.totalUsers)} активированы`,
      tone: 'neutral'
    },
    {
      label: 'Time to value (median)',
      value: formatMinutes(ttv.median?.minutes),
      meta: `≤ 5 мин: ${formatCount(ttv.distribution?.within5Min)}`,
      tone: 'neutral'
    },
    {
      label: 'Retention D7',
      value: formatPercent(day7.ratePercent),
      meta: `${formatCount(day7.retainedUsers)} из ${formatCount(day7.eligibleUsers)} удержались`,
      tone: 'neutral'
    },
    {
      label: 'Retention D30',
      value: formatPercent(day30.ratePercent),
      meta: healthLabel(day30.health) ? `Health: ${healthLabel(day30.health)}` : '—',
      tone: day30.health || 'neutral'
    },
    {
      label: 'Stickiness (summaries)',
      value: formatPercent(stickinessSummaries.ratioPercent),
      meta: `DAU: ${formatCount(stickinessSummaries.dau)} · MAU: ${formatCount(stickinessSummaries.mau)}`,
      tone: 'neutral'
    }
  ];

  return (
    <div className="stats-section">
      <div className="stats-header">
        <h2>Продукт</h2>
        <div className="stats-caption">Activation · Time-to-value · Retention · Stickiness</div>
      </div>

      <div className="stats-grid product-metrics-grid">
        {cards.map((card) => (
          <div key={card.label} className={`stat-card product-stat-card tone-${card.tone || 'neutral'}`}>
            <div className="stat-header-content">
              <h3>{card.label}</h3>
              {card.tone && card.tone !== 'neutral' && (
                <span className={`health-badge health-${card.tone}`}>{healthLabel(card.tone) || card.tone}</span>
              )}
            </div>
            <div className="stat-value">{card.value}</div>
            <div className="stat-meta">{card.meta}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductMetricsGrid;

